/* unplugin-vue-components disabled */import { render } from "./UserJob.vue?vue&type=template&id=7d36640c&scoped=true"
import script from "./UserJob.vue?vue&type=script&lang=js"
export * from "./UserJob.vue?vue&type=script&lang=js"

import "./UserJob.vue?vue&type=style&index=0&id=7d36640c&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d36640c"]])

export default __exports__